(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.currentScript.closest('section').querySelector('.custom-hero__inner');
    if (!root) return;
    var v = "{{ section.settings.mobile_position }}";
    var h = "{{ section.settings.mobile_alignment }}";
    root.classList.add('pos-' + v);
    root.classList.add('align-' + h);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-list-item button');

  function switchTab(event) {
    const activeClass = 'active';
    const target = event.target;
    const tabNum = target.getAttribute('aria-controls');

    // Find all tab panels and tabs
    const panels = document.querySelectorAll('.tab-panel');
    const tabButtons = document.querySelectorAll('.tab-list-item button');

    // Hide all tab panels and remove active class from tabs
    panels.forEach(panel => panel.classList.remove(activeClass));
    tabButtons.forEach(tab => {
      tab.setAttribute('aria-selected', 'false');
      tab.parentElement.classList.remove(activeClass);
    });

    // Show the clicked tab panel and set the tab as active
    document.getElementById(tabNum).classList.add(activeClass);
    target.setAttribute('aria-selected', 'true');
    target.parentElement.classList.add(activeClass);
  }

  // Attach the event listener to each tab
  tabs.forEach(tab => {
    tab.addEventListener('click', switchTab);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text-scroll"] && !Shopify.designMode) return;
  try {
    
const sections = document.querySelectorAll(".theme-video.alternate .images-with-text-scroll__item .images-with-text-scroll__text");

// for each section set grid-row to index
sections.forEach((section, index) => {
  section.style.gridRow = 2 * index + 1
});

  } catch(e) { console.error(e); }
})();
})();
